import { translate } from '@washed/i18n';
import { Reveal } from '../motion/Reveal.js';
import { brandify } from '../components/Brand.js';
import styles from './Marketplace.module.css';

export interface MarketplaceProps {
  locale: 'fr' | 'en';
}

/** Editorial marketplace-statement section. No card, no box — type on the open background. */
export function Marketplace({ locale }: MarketplaceProps) {
  const t = (k: Parameters<typeof translate>[0]) => translate(k, locale);

  const body = t('marketing.marketplace.body');
  const tagline =
    locale === 'fr'
      ? 'Une relation suivie, mois après mois.'
      : 'A consistent relationship, month after month.';

  return (
    <section
      className={`${styles.marketplace} u-editorial`}
      aria-label={
        locale === 'fr'
          ? 'Washed est une plateforme, pas une laverie'
          : 'Washed is a platform, not a laundromat'
      }
    >
      <div className={styles.inner}>
        <div className={`u-hair ${styles.hair}`} role="separator" aria-hidden="true" />
        <Reveal as="p" className={styles.body}>
          {brandify(body)}
        </Reveal>
        <Reveal as="p" className={styles.tagline} i={1}>
          {tagline}
        </Reveal>
      </div>
    </section>
  );
}
